import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { fetchData, putData } from "../../../utils/fetch";
import { Input, Switch, Checkbox, Button, message, Space } from "antd";

export default function UserEdit() {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [active, setActive] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [isPoster, setIsPoster] = useState(false);
  const [isSales, setIsSales] = useState(false);

  useEffect(() => {
    async function loadUser() {
      try {
        const data = await fetchData(`admin/users/${id}`);
        setUser(data);
        setActive(data.status === 1);
      } catch (error) {
        console.error("Error loading user.");
      }
    }
    async function loadPermissions() {
      try {
        const data = await fetchData(`admin/authassignment/${id}`);
        setPermissions(data);
        setIsPoster(data.some((item) => item.itemname === "poster"));
        setIsSales(data.some((item) => item.itemname === "sales"));
      } catch (error) {
        console.error("Error loading user.");
      }
    }

    loadUser();
    loadPermissions();
  }, [id]);

  const updateUser = async () => {
    if (!user) return;

    const newUser = {
      id: user.id,
      firstname: user.firstname,
      lastname: user.lastname,
      email: user.email,
      phone: user.phone,
      status: active,
    };

    const newAuthAssignments = [];
    if (isPoster) newAuthAssignments.push("poster");
    if (isSales) newAuthAssignments.push("sales");

    const authPayload = {
      userid: user.id,
      roles: newAuthAssignments,
    };

    try {
      const userResponse = await putData(`admin/user/update/`, newUser, user.language);
      if (userResponse.success) {
        message.success("User updated successfully.");
      } else {
        message.error("Failed to update user: " + userResponse.message);
      }
    } catch (error) {
      message.error("Error updating user.");
    }

    try {
      const authResponse = await putData(`admin/authassignment/update/`, authPayload, user.language);
      if (authResponse.success) {
        // message.success("Roles updated successfully");
      } else {
        message.error("Failed to update roles: " + authResponse.message);
      }
    } catch (error) {
      message.error("Error updating roles.");
    }
  };

  if (!user) return <div>Loading...</div>;

  return (
    <div style={{ padding: "20px", maxWidth: 600 }}>
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <label>Meno</label>
        <Input value={user.firstname} onChange={(e) => setUser({ ...user, firstname: e.target.value })} />

        <label>Priezvisko</label>
        <Input value={user.lastname} onChange={(e) => setUser({ ...user, lastname: e.target.value })} />

        <label>Email</label>
        <Input value={user.email} onChange={(e) => setUser({ ...user, email: e.target.value })} />

        <label>Telefón</label>
        <Input value={user.phone} onChange={(e) => setUser({ ...user, phone: e.target.value })} />

        <label>Status</label>
        <Switch checked={active} onChange={setActive} />

        <label>Role</label>
        <Checkbox checked={isPoster} onChange={() => setIsPoster(!isPoster)}>Redaktor</Checkbox>
        <Checkbox checked={isSales} onChange={() => setIsSales(!isSales)}>Predajca</Checkbox>

        <Button type="primary" onClick={updateUser}>Uložiť</Button>
      </Space>
    </div>
  );
}
